
import { defineComponent } from 'vue';
import Form from '@/shared/mixins/Form';
import { estateAgencyService } from '@/estate-agency/EstateAgencyService';
import EstateAgentPublicListItem from '@/estate-agent/components/EstateAgentPublicListItem.vue';
import ResizableImage from '@/shared/components/ResizableImage.vue';
import { Point } from '@/shared/models/Point';
import MapPositionReadonly from '@/shared/components/MapPositionReadonly.vue';
import { OfferListMode } from '@/ad/models/OfferListMode';
import AdOfferList from '@/ad/components/AdOfferList.vue';
import ReadMore from '@/shared/components/ReadMore.vue';
import { imageService } from '@/shared/services/ImageService';

export default defineComponent({
  name: 'EstateAgencyPublicProfile',
  mixins: [Form],
  components: {
    ResizableImage,
    EstateAgentPublicListItem,
    MapPositionReadonly,
    AdOfferList,
    ReadMore,
  },
  props: {
    urlName: { type: String, required: true },
  },
  data() {
    return {
      estateAgency: {} as null | any,
      estateAgents: [],
      position: null as null | Point,
      webDomain: null as null | string,
      mode: OfferListMode.estateagency,
    };
  },
  computed: {
    image(): null | string {
      return imageService.getImage(this.estateAgency.photoRelativeUrl, null, {
        width: 200,
        height: 112.5,
      });
    },
  },
  async created() {
    this.isLoading = true;
    try {
      const result = await estateAgencyService.getByUrlName(this.urlName);
      this.estateAgency = result.data;
      this.position = { lat: this.estateAgency.latitude, lng: this.estateAgency.longitude };
      try {
        if (this.estateAgency.website) {
          try {
            const url = new URL(this.estateAgency.website);
            this.webDomain = url.hostname;
          } catch (error) {
            console.warn(error.message);
          }
        }
      } catch (err) {
        console.error(err);
      }
      await this.loadAgents(this.estateAgency.estateAgencyId);
    } catch (error) {
      if (error && error.response && error.response.status === 404) {
        this.$router.push({ name: '404' });
      } else {
        console.error(error);
      }
    }
  },
  methods: {
    async loadAgents(estateAgencyId: number) {
      const resultAgents = await estateAgencyService.getEstateAgents(estateAgencyId);
      this.estateAgents = resultAgents.data.data;
    },
    async translate(showTranslation) {
      const params = {} as any;
      params.languageId = 'en';
      const result = await estateAgencyService.getDescription(this.estateAgency.estateAgencyId, params);
      this.estateAgency.descriptionEn = result.data.description;
      showTranslation();
    },
  },
});
